<script lang="ts">
  import classNames from "classnames";

  export let fullWidth: boolean = false;
</script>

<article class={classNames("article-prose prose", fullWidth ? '!max-w-full' : '')}>
  {#if $$slots["abstract"]}
    <div class="article-abstract">
      <slot name="abstract" />
    </div>
  {/if}

  <slot />
</article>

<style type="text/scss" lang="scss" scoped>
  .article-prose {
    @apply mx-auto;
    @apply lg:prose-lg;
  }

  .article-abstract {
    @apply font-serif font-medium;
    @apply text-md md:text-2xl;
    @apply text-gray-900;
  }
</style>
